export enum CartOperatorEnum {
  INIT,
  REMOVE_ITEM,
  ADD_CART_PRODUCT,
  UPDATE_PLURAL_CART_PRODUCT_QUANTITY,
  REMOVE_CART_PRODUCTS,
  CLEAR_CART,
}
